<template>
  <pre><code>{{ elasticsearchInfo }}</code></pre>
</template>

<script>
export default {
  name: "ESHealth",
  data() {
    return {
      elasticsearchInfo: {}
    };
  },
  inject: ["runtimeConfig"],
  computed: {
    authToken() {
      const { user, pass } = this.runtimeConfig.elasticsearch;
      return btoa(`${user}:${pass}`);
    },
    endpoint() {
      const { protocol, host } = this.runtimeConfig.elasticsearch;
      return `${protocol}://${host}`;
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      fetch(this.endpoint, {
        method: "GET",
        headers: new Headers({ Authorization: `"Basic ${this.authToken}"` })
      })
        .then(response => response.json())
        .then(json => {
          this.elasticsearchInfo = json;
        });
    }
  }
};
</script>
